export default __webpack_public_path__ + "static/media/Promueve.a3af632d.svg";